import React from 'react';
import {
   PageHeader,
   PageTitle,
   SessionsTab,
   Wrapper,
   useVendoData,
} from '@/pages/Admin/Vendo';

const WifiSessions = () => {
   useVendoData();
   return (
      <Wrapper>
         <PageHeader>
            <PageTitle>Sessions</PageTitle>
         </PageHeader>
         <SessionsTab />
      </Wrapper>
   );
};

export default WifiSessions;
